import { render, staticRenderFns } from "./MongoObjectSet.vue?vue&type=template&id=10c89988&scoped=true&"
import script from "./MongoObjectSet.vue?vue&type=script&lang=js&"
export * from "./MongoObjectSet.vue?vue&type=script&lang=js&"
import style0 from "./MongoObjectSet.vue?vue&type=style&index=0&id=10c89988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c89988",
  null
  
)

component.options.__file = "MongoObjectSet.vue"
export default component.exports